// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"320":"0b2970f9","363":"6b6f4c4e"}[chunkId] + ".js";
};